import { XMLParser, XMLBuilder } from 'fast-xml-parser';
import { MemberType } from '../../../shared/interfaces/crm-marketing-list.interface';
import { logger } from '../../logger.service';
import {
  accountTemplate,
  contactTemplate,
  leadTemplate,
} from '../templates/entity.template';

export const extendQueryEntityList = (
  type: MemberType,
  query: string,
): string => {
  const xmlParser = new XMLParser({
    ignoreAttributes: false,
    allowBooleanAttributes: true,
  });
  const xmlBuilder = new XMLBuilder({
    ignoreAttributes: false,
    suppressUnpairedNode: false,
    suppressBooleanAttributes: false,
    unpairedTags: ['attribute', 'condition', 'order'],
  });

  switch (type) {
    case 'contact': {
      const xmlObj = xmlParser.parse(query);
      const attributes = contactTemplate.map((i) => ({ '@_name': `${i}` }));
      xmlObj.fetch.entity.attribute = attributes;

      const extendedQuery = xmlBuilder.build(xmlObj);
      return extendedQuery;
    }

    case 'account': {
      const xmlObj = xmlParser.parse(query);
      const attributes = accountTemplate.map((i) => ({ '@_name': `${i}` }));
      xmlObj.fetch.entity.attribute = attributes;

      const extendedQuery = xmlBuilder.build(xmlObj);
      return extendedQuery;
    }

    case 'lead': {
      const xmlObj = xmlParser.parse(query);
      const attributes = leadTemplate.map((i) => ({ '@_name': `${i}` }));
      xmlObj.fetch.entity.attribute = attributes;

      const extendedQuery = xmlBuilder.build(xmlObj);
      return extendedQuery;
    }

    default: {
      logger.warn('No way to extend query, not found type');
      return query;
    }
  }
};
